import { AxiosInstance } from 'axios';
import { createContextAwareHandlers } from './instance';

export const getEmbedConfig = (instance: AxiosInstance) => async (reportId: string, partnershipId: string): Promise<EmbedConfig> => {
  const { data } = await instance.get<EmbedConfig>(`partnerships/${partnershipId}/analytics/powerbi/reports/${reportId}`);
  return data;
};

const handlers = {
  getEmbedConfig,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createAnalyticsApi = (context: PortalContext) => {
  return createContextAwareHandlers(context, handlers);
};
export default createAnalyticsApi;
